export enum ActionId {
	ABOUT_LINK = "About_HiDrive",
	DESKTOP_AD = "Discover_HiDrive",
	SMALL_AD = "Mobile_HiDrive",
}
